export default __webpack_public_path__ + "static/media/Honor 9781408312933.4014fe4f.jpg";